/**
 * @module components/Form/ButtonCurrentLocation
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Button for getting current user location using Bootstrap 3
 */

import { Button } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';


type Props = {
  bsStyle?: string,
  onCoordinates: FormOnCoordinates,
}


/**
 * React component
 * ===============
 */
const ButtonCurrentLocation = ({
  onCoordinates,
  bsStyle = 'default',
}: Props) => {
  const [ lang ] = useLanguageState();
  return (
    <Button
      bsStyle={bsStyle}
      style={{width:'100%'}}
      onClick={() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            onCoordinates(position.coords.latitude, position.coords.longitude);
          });
        }
      }}
    >
      {lang.form.currentLocation}
    </Button>
  );
}

export default ButtonCurrentLocation;
